<div class="">
  <app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>

  <form novalidate [formGroup]="form" *ngIf="form">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24">
        <p class="tw-text-gray-700 tw-text-xl">Hábitos del paciente</p>
        <p class="text-info tw-mb-5">Los hábitos del paciente nos proporcionan una valiosa información para poder
          diagnosticar de manera más eficiente. Ingresa la información solicitada.</p>
      </div>
    </div>

    <!-- alcohol   -->
    <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100" formGroupName="alcohol">
      <div nz-row [nzGutter]="[30, 30]">
        <div nz-col [nzXs]="24" [nzMd]="8">
          <label nz-checkbox formControlName="drinkAlcohol" class="tw-flex tw-items-center">
            <div class="tw-flex tw-items-center">
              <img src="./../../../assets/images/icons/icons8-cerveza-100.png" class="tw-w-8 tw-mr-2" alt="">
              <p class="text-info">¿Bebe alcohol?</p>
            </div>
          </label>
        </div>
        <div nz-col [nzXs]="24" [nzMd]="8">
          <nz-select [nzDisabled]="!form.get('alcohol')?.get('drinkAlcohol')?.value" formControlName="drinkAlcoholFrequency" nzBorderless
                     class="tw-w-full">
            <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value"
                       [nzLabel]="frequency.label"></nz-option>
          </nz-select>
        </div>
        <div nz-col [nzXs]="24" [nzMd]="8">
          <div class="tw-flex tw-items-center tw-justify-between">
            <p class="text-info tw-mr-2">¿Cuántas copas bebe al día?</p>
            <nz-input-number [nzDisabled]="!form.get('alcohol')?.get('drinkAlcohol')?.value" [nzMin]="0"
                             formControlName="cupAlcoholPerDay" style="max-width: 60px;"></nz-input-number>
          </div>
        </div>
      </div>
    </div>

    <!-- fumar   -->
    <div class="tw-mt-5 tw-p-5 tw-mb-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100" formGroupName="smoke">
      <div nz-row [nzGutter]="[30, 30]">
        <div nz-col [nzXs]="24" [nzMd]="8">
          <label nz-checkbox formControlName="smoke" class="tw-flex tw-items-center">
            <div class="tw-flex tw-items-center">
              <img src="./../../../assets/images/icons/icons8-cigar-100.png" class="tw-w-8 tw-mr-2" alt="">
              <p class="text-info">¿Fuma?</p>
            </div>
          </label>
        </div>
        <div nz-col [nzXs]="24" [nzMd]="8">
          <nz-select [nzDisabled]="!form.get('smoke')?.get('smoke')?.value" formControlName="smokeFrequency" nzBorderless
                     class="tw-w-full">
            <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value"
                       [nzLabel]="frequency.label"></nz-option>
          </nz-select>
        </div>
        <div nz-col [nzXs]="24" [nzMd]="8">
          <div class="tw-flex tw-items-center tw-justify-between">
            <p class="text-info tw-mr-2">¿Cuántos cigarros fuma al día?</p>
            <nz-input-number [nzDisabled]="!form.get('smoke')?.get('smoke')?.value" [nzMin]="0" formControlName="cigarettesPerDay"
                             style="max-width: 60px;"></nz-input-number>
          </div>
        </div>
      </div>
    </div>

    <!-- actividades enriquecedoras   -->
    <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100 tw-mb-5" formGroupName="enrichingActivities">
      <div nz-row [nzGutter]="[30, 30]">
        <div nz-col [nzXs]="24" [nzMd]="8">
          <label nz-checkbox formControlName="hasActivity" class="tw-flex tw-items-center">
            <div class="tw-flex tw-items-center">
              <img src="./../../../assets/images/icons/icons8-activities-64.png" class="tw-w-8 tw-mr-2" alt="">
              <p class="text-info">Actividades enriquecedoras</p>
            </div>
          </label>
        </div>
        <div nz-col [nzXs]="24" [nzMd]="8">
          <nz-select [nzDisabled]="!form.get('enrichingActivities')?.get('hasActivity')?.value" formControlName="activity" nzBorderless class="tw-w-full" [nzDropdownRender]="renderTemplateMoreOption">
            <nz-option *ngFor="let activity of enrichingActivities" [nzValue]="activity" [nzLabel]="activity"></nz-option>
          </nz-select>
          <ng-template #renderTemplateMoreOption>
            <nz-divider style="margin: 5px 0;"></nz-divider>
            <div class="container-more-option">
              <input type="text" nz-input #inputElement placeholder="Otra opción" />
              <a class="add-item" (click)="onAddOtherEnrichingActivity(inputElement)">
                <button nz-button nzType="default" class="btn-default"><i nz-icon nzType="plus" nzTheme="outline"></i></button>
              </a>
            </div>
          </ng-template>
        </div>
        <div nz-col [nzXs]="24" [nzMd]="8">
          <div class="tw-flex tw-items-center tw-justify-between">
            <p class="text-info tw-mr-2">¿Cuántos días a la semana?</p>
            <nz-input-number [nzDisabled]="!form.get('enrichingActivities')?.get('hasActivity')?.value" [nzMin]="0" [nzMax]="7" formControlName="frequency" style="max-width: 60px;"></nz-input-number>
          </div>
        </div>
      </div>
    </div>

    <!--  sueño  -->
    <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100" formGroupName="sleep">
      <div nz-row [nzGutter]="[30, 30]">
        <div nz-col
             [nzXs]="24"
             [nzMd]="12"
             [nzLg]="8"
             class="d-flex flex-column justify-content-between">
          <div class="input-label-form">¿A qué hora suele dormirse?</div>
          <nz-time-picker
            @fadeInAnimation
            formControlName="whatTimeDoYouUsuallyGoToSleep"
            [nzPlaceHolder]="'10:00'"
            [required]="true"
            (ngModelChange)="onChangeStartDate($event)"
            nzFormat="HH:mm"></nz-time-picker>
        </div>

        <div nz-col
             [nzXs]="24"
             [nzMd]="12"
             [nzLg]="8"
             class="d-flex flex-column justify-content-between">
          <div class="input-label-form">¿A qué hora suele levantarse?</div>
          <nz-time-picker
            @fadeInAnimation
            formControlName="whatTimeDoYouUsuallyGetUp"
            [nzPlaceHolder]="'10:00'"
            [required]="true"
            (ngModelChange)="onChangeEndDate($event)"
            nzFormat="HH:mm"></nz-time-picker>
          <!--<app-message-field [field]="nutritionalForm.get('nutritionalRegimen')"></app-message-field>-->
        </div>

        <div nz-col
             [nzXs]="24"
             [nzMd]="12"
             [nzLg]="8"
             class="d-flex flex-column justify-content-between">
          <div class="input-label-form">¿Cuántas horas duerme de promedio por noche?</div>
          <nz-input-number
            [required]="true"
            [nzMax]="1000000"
            [nzPlaceHolder]="'8'"
            nzPlaceHolder="Folio inicial"
            formControlName="howManyHoursDoYouSleepOnAveragePerNight"
            [nzStep]="1"></nz-input-number>
          <!--<app-message-field [field]="nutritionalForm.get('nutritionalRegimen')"></app-message-field>-->
        </div>
      </div>
    </div>

    <nz-divider class="tw-opacity-0"></nz-divider>

    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24">
        <p class="tw-text-gray-700 tw-text-xl">Actitud del paciente</p>
        <p class="text-info tw-mb-5">El estado de ánimo del paciente tiene un impacto en su salud y es importante tener en cuente estos detalles a fondo. Ingresa la información solicitada.</p>
      </div>
    </div>

    <!--  afectividad  -->
    <div nz-row [nzGutter]="[30, 30]" formGroupName="environmentAffectivity">
      <div nz-col [nzXs]="24" [nzMd]="12" [nzLg]="12" class="d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">Me siento feliz a menudo</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="feelHappyOften" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info tw-mt-3">{{ this.form.get('environmentAffectivity')?.get('feelHappyOften')?.value | getStatementStatus}}</p>
        </div>
        <!--      <app-message-field [field]="form.get('feelHappyOften')"></app-message-field>-->
      </div>
      <div nz-col [nzXs]="24" [nzMd]="12" [nzLg]="12" class="d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">Puedo contar con mis amigos y/o familiares en tiempos de crisis.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="trustWithFamilyAndFriends" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info tw-mt-3">{{ this.form.get('environmentAffectivity')?.get('trustWithFamilyAndFriends')?.value | getStatementStatus}}</p>
        </div>
        <!--      <app-message-field [field]="form.get('feelHappyOften')"></app-message-field>-->
      </div>
    </div>

    <!-- actitud   -->
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24" [nzMd]="12" [nzLg]="12" class="d-flex flex-column justify-content-between" formGroupName="attitude">
        <div class="input-label-form tw-h-3/6">Creo que tengo el potencial para alcanzar mis metas.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="potentialToReachMyGoals" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info tw-mt-3">{{ this.form.get('attitude')?.get('potentialToReachMyGoals')?.value | getStatementStatus}}</p>
        </div>
      </div>

      <!-- estrés -->
      <div nz-col
           [nzXs]="24"
           [nzMd]="24"
           [nzLg]="24"
           class="d-flex flex-column justify-content-between" formGroupName="stress">
        <div class="input-label-form">¿Con qué frecuencia has sentido que las dificultades se acumulan tanto que no puedes superarlas?</div>

        <nz-select formControlName="howOftenHaveFeltThatDifficultiesArePilingUpSoMuchThatCanOvercomeThem" nzPlaceHolder="Seleccione la opción">
          <nz-option *ngFor="let option of options" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-select>
      </div>

    </div>

    <nz-divider class="tw-opacity-0"></nz-divider>

    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24">
        <p class="tw-text-gray-700 tw-text-xl">Alimentación del paciente</p>
        <p class="text-info tw-mb-5">Los hábitos alimenticios del paciente son, sin duda, fundamentales para poder llevar a cabo un plan de alimentación personal y eficiente. Ingresa la información solicitada.</p>
      </div>
    </div>

    <!--  alimentación  -->
    <div nz-row [nzGutter]="[30, 30]" formGroupName="nutritionalHistory">

      <div nz-col
           [nzXs]="24"
           [nzMd]="12"
           class="d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Acostumbra alguna alimentación especial?</div>
        <nz-select formControlName="feedingPreference" nzPlaceHolder="Seleccione la opción"
                   [nzDropdownRender]="renderTemplateMoreOptionRegimen">
          <nz-option *ngFor="let regimen of nutritionalRegimen" [nzValue]="regimen.value" [nzLabel]="regimen.label"></nz-option>
        </nz-select>

        <ng-template #renderTemplateMoreOptionRegimen>
          <nz-divider style="margin: 5px 0;"></nz-divider>
          <div class="container-more-option">
            <input type="text" nz-input #inputElement placeholder="Otra opción" />
            <a class="add-item" (click)="onAddOtherNutritionalRegimen(inputElement)">
              <button nz-button nzType="default" class="btn-default"><i nz-icon nzType="plus" nzTheme="outline"></i></button>
            </a>
          </div>
        </ng-template>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="12" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">¿Es alérgico a algún medicamento?</p>
        <textarea [nzAutosize]="{ minRows: 1, maxRows: 2 }" nz-input class="tw-block" placeholder="Agrega los medicamentos ..." formControlName="allergicToAnyMedication"></textarea>
      </div>

      <div nz-col [nzXs]="24" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Añade qué alimentos no le gustaría consumir al paciente en su plan de alimentación.</p>

        <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-3 tw-mb-3">
          <div class="more-options ingredient-tag" *ngFor="let ingredient of excludedDislikeIngredients; index as i">
            <p class="text-info tw-text-gray-700">{{ingredient.ingredientName}}</p>
            <div *ngIf="!(isPatient$ | async)" nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger" (click)="onRemoveDislikeIngredient(i)">
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </div>
          </div>
          <p *ngIf="excludedDislikeIngredients.length === 0 && (isPatient$ | async)" class="text-info">No se han registrado alimentos</p>
        </div>
        <app-ingredient-selector
          *ngIf="!(isPatient$ | async)"
          [disabled]="(this.isPatient$ | async)"
          [hasCategoryFilter]="true"
          [hasIngredientName]="true"
          [showForm]="true"
          [excludedIngredients]="this.excludedDislikeIngredientIds"
          (selected)="onSelectedDislikeIngredient($event)"
        ></app-ingredient-selector>
      </div>

      <div nz-col [nzXs]="24" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Añade qué alimentos le producen alergia al paciente.</p>

        <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-3 tw-mb-3">
          <div class="more-options ingredient-tag tw-items-start" *ngFor="let ingredient of excludedAllergyIngredients; index as i">
            <div class="text-info">
              <p class="tw-text-gray-700">{{ingredient.ingredientName}}</p>
              <p class="tw-text-gray-400">{{ingredient.allergyDate | date:this.platformConfig.FORMAT.DATE.DDMMYYYY }}</p>
            </div>
            <div *ngIf="!(isPatient$ | async)" nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger"
                 (click)="onRemoveAllergyIngredient(i)">
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </div>
          </div>
          <p *ngIf="excludedAllergyIngredients.length === 0 && (isPatient$ | async)" class="text-info">No se han registrado alergias</p>
        </div>
        <button
          *ngIf="!(isPatient$ | async)"
          [disabled]="(this.isPatient$ | async)"
          nz-popover="" nzPopoverTitle="" [nzPopoverContent]="'Agregar nueva alergia'" nzPopoverMouseEnterDelay="0.3"
          nzPopoverPlacement="topLeft"
          (click)="onOpenModalAddAllergy()"
          nz-button
          class="add-category-btn tw-w-max"
          @fadeInAnimation>
          <i nz-icon nzType="plus" nzTheme="outline" style="font-size: 11px;"></i>
        </button>
      </div>
    </div>

    <div nz-row [nzGutter]="[30, 30]" class="mt-sm" formGroupName="nutritionalPhysicalExamination">
      <div nz-col [nzXs]="24" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Agrega observaciones físicas nutricionales</p>
        <textarea [nzAutosize]="{ minRows: 3, maxRows: 6 }" nz-input class="tw-block" placeholder="Agrega signos detectados al paciente ..." formControlName="observations"></textarea>
      </div>
    </div>

    <!-- bioquímicos   -->
    <div nz-row [nzGutter]="[30, 30]" class="mt-sm" formGroupName="biochemical">
      <div nz-col [nzXs]="8" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Glucosa</p>
        <nz-input-group [nzAddOnAfter]="tplMgdL">
          <nz-input-number
            [nzMin]="0"
            formControlName="glucose"></nz-input-number>
        </nz-input-group>
      </div>
      <div nz-col [nzXs]="8" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Colesterol</p>
        <nz-input-group [nzAddOnAfter]="tplMgdL">
          <nz-input-number
            [nzMin]="0"
            formControlName="cholesterol"></nz-input-number>
        </nz-input-group>
      </div>
      <div nz-col [nzXs]="8" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Triglicéridos</p>
        <nz-input-group [nzAddOnAfter]="tplMgdL">
          <nz-input-number
            [nzMin]="0"
            formControlName="tg"></nz-input-number>
        </nz-input-group>
      </div>
      <div nz-col [nzXs]="8" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Lipoproteínas de alta densidad</p>
        <nz-input-group [nzAddOnAfter]="tplMgdL">
          <nz-input-number
            [nzMin]="0"
            formControlName="hdl"></nz-input-number>
        </nz-input-group>
      </div>
      <div nz-col [nzXs]="8" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Lipoproteínas de baja densidad</p>
        <nz-input-group [nzAddOnAfter]="tplMddL">
          <nz-input-number
            [nzMin]="0"
            formControlName="ldl"></nz-input-number>
        </nz-input-group>
      </div>
      <div nz-col [nzXs]="8" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Hemoglobina glicosilada</p>
        <nz-input-group [nzAddOnAfter]="tplPercentage">
          <nz-input-number
            [nzMin]="0"
            formControlName="hbGlic"></nz-input-number>
        </nz-input-group>
      </div>
      <div nz-col [nzXs]="8" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Insulina</p>
        <nz-input-group [nzAddOnAfter]="tplmul">
          <nz-input-number
            [nzMin]="0"
            formControlName="insulin"></nz-input-number>
        </nz-input-group>
      </div>
      <div nz-col [nzXs]="8" class="d-flex flex-column justify-content-between">
        <p class="input-label-form">Vitamina D3</p>
        <nz-input-group [nzAddOnAfter]="tplNgml">
          <nz-input-number
            [nzMin]="0"
            formControlName="vitaminD3"></nz-input-number>
        </nz-input-group>
      </div>
    </div>

    <nz-divider class="tw-opacity-0"></nz-divider>

    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24">
        <p class="tw-text-gray-700 tw-text-xl">Actividad física del paciente</p>
        <p class="text-info tw-mb-5">La actividad física del paciente nos brinda información valiosa acerca de su estilo de vida y esto tiene un impacto en su plan de alimentación. Ingresa la información solicitada.</p>
      </div>
    </div>

    <!-- actividad física   -->
    <div nz-row [nzGutter]="[30, 30]" formGroupName="physicalActivity">
      <div nz-col [nzSpan]="24" class="d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Cuál es su ocupación actualmente?</div>
        <textarea [nzAutosize]="{ minRows: 3, maxRows: 3 }" nz-input formControlName="occupation" placeholder="Por ejemplo, programador"></textarea>
      </div>
      <div nz-col [nzXs]="24" [nzMd]="12"
           class="d-flex flex-column">
        <div class="input-label-form">Nivel de actividad física</div>
        <nz-select formControlName="physicalLevelActivity" nzPlaceHolder="Seleccione la opción">
          <nz-option
            nzCustomContent
            [nzValue]="physicalActivityLevelEnum.NO_ACTIVITY"
            [nzLabel]="physicalActivityLevelEnum.NO_ACTIVITY | getTranslateEnum:'physicalActivityLevel'">
            <p class="tw-font-semibold tw-text-gray-700">{{ physicalActivityLevelEnum.NO_ACTIVITY | getTranslateEnum:'physicalActivityLevel' }}</p>
            <p class="text-info"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span> dormir o reclinarme</p>
          </nz-option>
          <nz-divider style="margin: 15px 0;"></nz-divider>
          <nz-option
            nzCustomContent
            [nzValue]="physicalActivityLevelEnum.LIGHT_EXERCISE"
            [nzLabel]="physicalActivityLevelEnum.LIGHT_EXERCISE | getTranslateEnum:'physicalActivityLevel'">
            <p class="tw-font-semibold tw-text-gray-700">{{ physicalActivityLevelEnum.LIGHT_EXERCISE | getTranslateEnum:'physicalActivityLevel' }}</p>
            <p class="text-info">1-3 días u horas a la semana</p>
            <p class="text-info tw-whitespace-normal"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>Ej. estar sentada(o) o de pie: ej. pintar, manejar, planchar, cocinar, trabajo de oficina</p>
          </nz-option>
          <nz-divider style="margin: 15px 0;"></nz-divider>
          <nz-option
            nzCustomContent
            [nzValue]="physicalActivityLevelEnum.MODERATE_EXERCISE"
            [nzLabel]="physicalActivityLevelEnum.MODERATE_EXERCISE | getTranslateEnum:'physicalActivityLevel'">
            <p class="tw-font-semibold tw-text-gray-700">{{ physicalActivityLevelEnum.MODERATE_EXERCISE | getTranslateEnum:'physicalActivityLevel' }}</p>
            <p class="text-info">3 a 5 días u horas a la semana</p>
            <p class="text-info tw-whitespace-normal"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>Ej. caminata moderada, elíptica, trotar, golf, trabajar en restaurante, cuidar a niños</p>
          </nz-option>
          <nz-option
            nzCustomContent
            [nzValue]="physicalActivityLevelEnum.HEAVY_EXERCISE"
            [nzLabel]="physicalActivityLevelEnum.HEAVY_EXERCISE | getTranslateEnum:'physicalActivityLevel'">
            <p class="tw-font-semibold tw-text-gray-700">{{ physicalActivityLevelEnum.HEAVY_EXERCISE | getTranslateEnum:'physicalActivityLevel' }}</p>
            <p class="text-info">6-7 días u horas a la semana</p>
            <p class="text-info tw-whitespace-normal"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>Ej. ciclismo, esquiar, tennis, ejercicios de resistencia, atletismo, caminata intensa, llevar una carga, etc. Con bastante desgaste</p>
          </nz-option>
          <nz-divider style="margin: 15px 0;"></nz-divider>
          <nz-option
            nzCustomContent
            [nzValue]="physicalActivityLevelEnum.VERY_HEAVY_EXERCISE"
            [nzLabel]="physicalActivityLevelEnum.VERY_HEAVY_EXERCISE | getTranslateEnum:'physicalActivityLevel'">
            <p class="tw-font-semibold tw-text-gray-700">{{ physicalActivityLevelEnum.VERY_HEAVY_EXERCISE | getTranslateEnum:'physicalActivityLevel' }}</p>
            <p class="text-info">2 veces al día o 4 a 5 horas diarias</p>
            <p class="text-info tw-whitespace-normal"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>Ej. basquetbol, futbol americano, soccer, escalar montañas, entrenamiento militar, boxear, ciclismo, atletismo</p>
          </nz-option>
        </nz-select>
<!--        <app-message-field [field]="form.get('physicalLevelActivity')"></app-message-field>-->
      </div>
      <div nz-col [nzXs]="24" [nzMd]="12"
           class="d-flex flex-column">
        <div class="input-label-form">Del 0 al 10 ¿Cuál es la intensidad del ejercicio?</div>
        <div class="tw-flex tw-items-center">
          <nz-slider formControlName="exerciseIntensity" [nzMin]="0" [nzMax]="10" [nzStep]="1" style="width: calc(100% - 75px);"></nz-slider>
          <p class="tw-text-gray-800 tw-text-sm tw-font-semibold tw-ml-3">{{ form.get('physicalActivity')?.get('exerciseIntensity')?.value || 0 }} <span class="tw-text-gray-600
            tw-text-sm">de
            10</span></p>
        </div>
<!--        <app-message-field [field]="form.get('exerciseIntensity')"></app-message-field>-->
      </div>

      <div nz-col [nzXs]="24" [nzMd]="12">
        <p class="input-label-form">¿Cuántos días a la semana realiza ejercicio?</p>
        <nz-input-group [nzAddOnAfter]="'días por semana'">
          <nz-input-number
            [nzMin]="0"
            formControlName="exercisePerWeek"></nz-input-number>
        </nz-input-group>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="12">
        <p class="input-label-form">¿Cuántas horas de ejercicio realizas al día?</p>
        <nz-radio-group nzButtonStyle="solid" formControlName="duration">
          <label nz-radio [nzValue]="0">0 a 2 horas</label>
          <label nz-radio [nzValue]="2">2 a 4 horas</label>
          <label nz-radio [nzValue]="4">más de 4 horas</label>
        </nz-radio-group>
      </div>

      <div nz-col [nzXs]="24">
        <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100 tw-mt-3 tw-w-full" @fadeInAnimation>
          <div class="tw-gray-700 tw-font-semibold tw-mb-3">SEDENTARISMO</div>
          <p class="text-info">¿Cuántas horas al día en promedio pasas sentado por relax o diversión, (suma todas)?</p>
          <p class="tw-text-gray-400 tw-mb-2">
            Ver películas, redes sociales o videojuegos en celular, tableta, computadora, hablar por teléfono sentado, estar tumbado en el sofá, otros juegos sedentarios.
          </p>
          <nz-radio-group nzButtonStyle="solid" formControlName="howManyHoursSpendSittingOrRelaxADay">
            <label nz-radio [nzValue]="0">0 a 2 horas</label>
            <label nz-radio [nzValue]="2">2 a 4 horas</label>
            <label nz-radio [nzValue]="4">más de 4 horas</label>
          </nz-radio-group>
          <p class="text-info tw-mt-5">¿Cuántas horas al día en promedio estás sentado sin pausa de activación por cuestiones de estudio, escuela, trabajo, traslados, (suma todas)?</p>
          <p class="tw-text-gray-400 tw-mb-2">
            Escuela, oficina, investigación, lectura, estudio, viaje en coche, vuelos, etc.
          </p>
          <nz-radio-group nzButtonStyle="solid" formControlName="howManyHoursSpendSittingPerStudySchoolWorkMovingADay">
            <label nz-radio [nzValue]="0">0 a 2 horas</label>
            <label nz-radio [nzValue]="2">2 a 4 horas</label>
            <label nz-radio [nzValue]="4">más de 4 horas</label>
          </nz-radio-group>
          <p class="text-info tw-mt-5 tw-mb-2">¿Sabes cuántos pasos caminas al día?</p>
          <nz-radio-group nzButtonStyle="solid" formControlName="howManyStepsWalkADay">
            <label nz-radio [nzValue]="4">menos de 3,000</label>
            <label nz-radio [nzValue]="1">más de 3,000 pero menos de 5,000</label>
            <label nz-radio [nzValue]="-1">más de 5,000 pero menos de 8,000</label>
            <label nz-radio [nzValue]="-3">hasta 10,000</label>
            <label nz-radio [nzValue]="-4">más de 10,000</label>
            <label nz-radio [nzValue]="0">no los he contado</label>
          </nz-radio-group>
        </div>
      </div>
    </div>

    <nz-divider class="tw-opacity-0"></nz-divider>

    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24">
        <p class="tw-text-gray-700 tw-text-xl">Historial médico del paciente</p>
        <p class="text-info tw-mb-5">La información médica del paciente es esencial para la elaboración del plan de alimentación, ya que las actividades tiene un impacto negativo en los alimentos que se pueden consumir. Ingresa la información solicitada.</p>
      </div>
    </div>

    <!--  enfermedades personales  -->
    <div nz-row [nzGutter]="[30, 30]" formGroupName="medicalPersonal">
      <div nz-col [nzXs]="24" class="d-flex flex-column justify-content-between">
        <label nz-checkbox formControlName="haveOrHaveHadAnyDisease" class="tw-flex tw-items-center">
          <p class="text-info">¿Tiene o ha padecido algún tipo de enfermedad?</p>
        </label>
        <p class="tw-text-gray-400 tw-mt-1">Si la respuesta es afirmativa, se mostrará un listado de enfermedades para que pueda seleccionarlas y añadir el control que lleva sobre ellas.</p>
      </div>
      <div nz-col [nzXs]="24" *ngIf="this.form.get('medicalPersonal')?.get('haveOrHaveHadAnyDisease')?.value">
        <nz-collapse nzGhost class="tw-w-full tw-shadow-none">
          <ng-template #header>
            <div class="tw-flex tw-items-center tw-h-4 tw-w-full tw-pr-7">
              <p class="tw-text-gray-900 tw-text-sm truncate">
                {{ 'Desplegar listado de enfermedades' }}.
              </p>
            </div>
          </ng-template>
          <nz-collapse-panel
            #collapse
            [nzHeader]="header">
            <app-record-history-personal-medical
              [isInnerRecord]="true"
              [recordMedicalPersonal]="this.form.get('medicalPersonal')?.get('recordMedicalPersonal')?.value"
            >
            </app-record-history-personal-medical>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </div>

    <nz-divider class="tw-opacity-0"></nz-divider>

    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24">
        <p class="tw-text-gray-700 tw-text-xl">Historial médico familiar del paciente</p>
        <p class="text-info tw-mb-5">La información médica familiar del paciente es esencial para la elaboración del plan de alimentación, ya que las actividades tiene un impacto negativo en los alimentos que se pueden consumir. Ingresa la información solicitada.</p>
      </div>
    </div>
    <!--  enfermedades heredo familiares  -->
    <div nz-row [nzGutter]="[30, 30]" formGroupName="medicalInheritedFamily">
      <div nz-col [nzXs]="24" class="d-flex flex-column justify-content-between">
        <label nz-checkbox formControlName="haveAFamilyMemberWithIllness" class="tw-flex tw-items-center">
          <p class="text-info">¿Tiene familiares que padezcan o hayan padecido alguna enfermedad?</p>
        </label>
        <p class="tw-text-gray-400 tw-mt-1">Si la respuesta es afirmativa, se mostrará un listado de enfermedades para que pueda seleccionarlas y añadir el control que lleva sobre ellas.</p>
      </div>
      <div nz-col [nzXs]="24" *ngIf="this.form.get('medicalInheritedFamily')?.get('haveAFamilyMemberWithIllness')?.value">
        <nz-collapse nzGhost class="tw-w-full tw-shadow-none">
          <ng-template #header>
            <div class="tw-flex tw-items-center tw-h-4 tw-w-full tw-pr-7">
              <p class="tw-text-gray-900 tw-text-sm truncate">
                {{ 'Desplegar listado de enfermedades' }}.
              </p>
            </div>
          </ng-template>
          <nz-collapse-panel
            #collapse
            [nzHeader]="header">
            <app-record-history-familial-medical
              [isInnerRecord]="true"
              [recordMedicalHerded]="this.form.get('medicalInheritedFamily')?.get('recordMedicalInheritedFamily')?.value"
            >
            </app-record-history-familial-medical>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </div>
  </form>
  <div class="d-flex justify-content-end" *ngIf="!(this.isPatient$ | async)">
    <button class="mt-xlg" nz-button nzType="primary" (click)="onSave()"><i nz-icon nzType="save" nzTheme="outline"></i>GUARDAR</button>
  </div>
</div>

<!-- templates de subfix para micronutrientes -->
<ng-template #tplGrdL>
  <p class="text-info">gr/dL</p>
</ng-template>
<ng-template #tplMgdL>
  <p class="text-info">mg/dL</p>
</ng-template>
<ng-template #tplMddL>
  <p class="text-info">md/dL</p>
</ng-template>
<ng-template #tplPercentage>
  <p class="text-info">%</p>
</ng-template>
<ng-template #tplmul>
  <p class="text-info">mU/L</p>
</ng-template>
<ng-template #tplNgml>
  <p class="text-info">ng/mL</p>
</ng-template>


<!-- modal para agregar alergias -->
<app-modal-add-allergy
  [isVisible]="this.modalAddAllergyVisible"
  [allergies]="this.excludedAllergyIngredients"
  (close)="this.onCloseModalAddAllergy($event)"
></app-modal-add-allergy>
